import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import styled from 'styled-components';
import { Box, Column } from '../../components/Flex';
import { BackgroundButton } from '../../components/Form';
import { HeadingOne } from '../../components/Text';
import { useRouter } from 'next/router';
import { loadStripe } from '@stripe/stripe-js';
import { COLORS } from '../../theme';
import axios from 'axios';
import base64url from 'base64url';
import { analytics } from '../../lib/analytics';

const Container = styled.div`
  width: 100%;
  max-width: 850px;
  margin-right: auto;
  margin-left: auto;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const TipContainer = styled(Column)`
  padding: 2rem 2.5rem;
  width: 100%;
  border: 1px solid #cacfe0;
  border-radius: 24px;
  opacity: 1;
  margin-bottom: 2rem;
`;

const TipQuestion = styled.p`
  margin: 0;
  font: normal normal bold 19px/29px Poppins;
  text-align: center;
  color: ${COLORS.BLACK};
`;

const TipAmountHeader = styled.p`
  margin: 0;
  font: normal normal bold 19px/29px Poppins;
  text-align: left;
  color: ${COLORS.BLACK};
`;

function Pay() {
  const router = useRouter();

  const [tipChoice, setTipChoice] = useState(null);
  const [tipAmount, setTipAmount] = useState('0');

  useEffect(() => {
    analytics.page(`Middleman Service Fee`);
  }, []);

  const payNow = async () => {
    const payload = router.query['payload'] as string;
    const decodedPayload = base64url.decode(payload);
    let json = JSON.parse(decodedPayload);

    if (tipChoice && tipAmount !== '0') {
      const parsedTip = parseFloat(tipAmount);
      if (!isNaN(parsedTip)) {
        json.line_items.push({
          price_data: {
            currency: 'usd',
            product_data: {
              name: `Service Tip`,
            },
            unit_amount: parsedTip * 100,
          },
          quantity: 1,
        });
      }
    }

    const resp = await axios.post(
      `${process.env.BACKEND_URI}/dashboard/middlemen/session`,
      json,
    );

    if (resp.data.sessionId) {
      analytics.track('User Started Middlemen Payment');

      const StripeInstance = await loadStripe(
        process.env.TIDAL_MM_STRIPE_TOKEN,
        {
          stripeAccount: json.stripeAccount,
        },
      );

      await StripeInstance.redirectToCheckout({
        sessionId: resp.data.sessionId,
      });
    }
  };

  return (
    <Container>
      <Head>
        <title>Middlemen Service Fee</title>
        <link
          rel="canonical"
          href={`https://www.tidalmarket.com/middlemen/pay`}
        />
      </Head>
      <HeadingOne>Middlemen Service Fee</HeadingOne>
      <Box height={20} />
      <TipContainer>
        <TipQuestion>Would you like to add a tip ?</TipQuestion>
        <OptionsContainer>
          <Column>
            <BackgroundButton onClick={() => setTipChoice(true)}>
              Yes
            </BackgroundButton>
          </Column>
          <Column>
            <BackgroundButton onClick={() => setTipChoice(false)}>
              No
            </BackgroundButton>
          </Column>
        </OptionsContainer>
        {tipChoice && (
          <>
            <div className="flex justify-center">
              <div className="my-3 w-full">
                <label
                  htmlFor="tipAmount"
                  className="form-label inline-block mb-2 font-bold text-lg"
                >
                  Enter tip amount
                </label>
                <input
                  // type="number"
                  className="form-control block w-full m-0 px-3 py-1.5 text-base font-normal bg-gray-100 bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out focus:bg-white focus:border-blue-600 focus:outline-none"
                  id="tipAmount"
                  type="text"
                  inputMode="numeric"
                  pattern="[-+]?[0-9]*[.,]?[0-9]+"
                  placeholder="0"
                  defaultValue={0}
                  onChange={(event) => {
                    const { value } = event.currentTarget;
                    setTipAmount(value);
                  }}
                />
              </div>
            </div>
          </>
        )}
        {tipChoice != undefined && (
          <>
            <Box height={20} />
            <BackgroundButton onClick={() => payNow()}>
              Pay Now
            </BackgroundButton>
          </>
        )}
      </TipContainer>
    </Container>
  );
}

export default Pay;
